import { render, staticRenderFns } from "./channels-stores-tab.vue?vue&type=template&id=3f0d43a2&scoped=true"
import script from "./channels-stores-tab.vue?vue&type=script&lang=js"
export * from "./channels-stores-tab.vue?vue&type=script&lang=js"
import style0 from "./channels-stores-tab.vue?vue&type=style&index=0&id=3f0d43a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d43a2",
  null
  
)

export default component.exports